export const calendarObjects = ["SOMEETING", "SOACTION"];
